import { useEffect } from "react";

const upsertMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const upsertLink = (rel, href) => {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Per-route SEO manager for this single-page app.
 * Sets title, meta description/keywords, canonical, Open Graph / Twitter,
 * and injects/removes a route-level JSON-LD block. Also fires a gtag page_view.
 */
const Seo = ({
  title,
  description,
  keywords,
  canonical,
  ogImage = "https://www.auracresthaven.com/images/two_storey_roadside_view.jpg",
  jsonLd,
}) => {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("name", "keywords", keywords);
    upsertLink("canonical", canonical);

    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", canonical);
    upsertMeta("property", "og:image", ogImage);
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);
    upsertMeta("name", "twitter:image", ogImage);

    // Route-level JSON-LD (replace or remove so pages don't leak schema into each other)
    const existing = document.getElementById("route-jsonld");
    if (jsonLd) {
      let script = existing;
      if (!script) {
        script = document.createElement("script");
        script.type = "application/ld+json";
        script.id = "route-jsonld";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (existing) {
      existing.remove();
    }

    // Google Ads / Analytics virtual page view on route change
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_title: title,
        page_path: window.location.pathname,
        page_location: window.location.href,
      });
    }
  }, [title, description, keywords, canonical, ogImage, jsonLd]);

  return null;
};

export default Seo;
